import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "app-sku-details-dropdown",
  templateUrl: "./sku-details-dropdown.component.html",
  styleUrl: "./sku-details-dropdown.component.scss",
})
export class SkuDetailsDropdownComponent implements OnChanges {
  @Input() dropdownOptions: any[] = [];
  @Output() actionBtnCallback = new EventEmitter<any>();

  selectedRegion: string = "";

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.dropdownOptions) {
      const options = changes.dropdownOptions.currentValue;
      this.selectedRegion = options[0]?.value;
    }
  }

  onLevelChange() {
    this.actionBtnCallback.emit(this.selectedRegion);
  }
}
